<template>
  <Navbar :title="'政策通'"></Navbar>
  <div class="content-bg" @click="hideSearch">
    <img class="img" src="@/assets/images/bg/bg_4@2x.png" />
    <div class="title">只需输入公司名称</div>
    <div class="sub-title">即可知道公司补贴</div>
    <div class="header">
      <!-- <div class="match-container-search" @click.stop="() => { }"> -->
      <div class="match-container-search" @click.stop="goSearchV2">
        <input type="text" placeholder="请输入企业名称" v-model="formSearch.search" @focus="handleInput" disabled />
        <div class="btn" @click="goSearchV2">
          <img src="@/assets/images/vector@2x.png" alt="">
        </div>
        <div class="detail" v-if="isFocus">
          <search-detail :searchList="searchList" :isSearch="isSearch" @toMatchDetail="toMatchDetail"
            :currentStr="currentSearchStr" @updateSearchStr="updateSearchStr" ref="searchDetails"></search-detail>
        </div>
      </div>
    </div>
    <van-empty description="暂无数据" v-show="emptyShow" />
    <van-list v-model:loading="loading" :finished="finished" finished-text="没有更多了" @load="getData" v-if="!emptyShow">
      <!-- 最近匹配 -->
      <div class="search-hot-list" v-if="hots && hots.length">
        <div v-for="(item, i) in hots" :key="i" class="policy-file-item">
          <div class="dot"></div>
          <div class="list-title">
            <div>{{ item.create_time }}</div>
            <div style="margin: 4px 0;">
              <span class="color_1">{{ item.nameView }} </span>快速匹配出了
              <span class="color_2">{{ item.policy_match_count }}</span>
              条项目申报
            </div>
            <div>
              可申报政策资金<span class="color_2">扶持资金：{{ item.money_scope }}万</span>
            </div>
          </div>
        </div>
      </div>
    </van-list>
  </div>

</template>
<script>
import { getLatestRecord, getCompanyLists } from "@/api/home"
import Navbar from '@/components/Navbar'
import SearchDetail from '@/components/SearchDetail.vue'

import { clickUrl, desensitization } from '@/utils'
import { getSearchHistory, setSearchHistory } from '@/utils/storage'
export default {

  data() {
    return {
      formSearch: {
        search: ''
      },
      searchList: [],
      isSearch: false,
      hots: [],
      loading: false,
      finished: false,
      isFocus: false,
      emptyShow: false,
      currentSearchStr: '',
      stoageHistory: [],
    }
  },
  components: { Navbar, SearchDetail },

  mounted() {
    this.stoageHistory = getSearchHistory() || []
    // this.getData()
    // this.search()
  },
  watch: {
    formSearch: {//深度监听，可监听到对象、数组的变化
      handler() {
        console.log(21436)
        this.formDebounce(this);
      },
      deep: true //true 深度监听
    }
  },
  methods: {
    formDebounce: debounce(function () {
      this.search()
    }, 1000),
    handleInput() {
      this.isFocus = true
    },
    hideSearch() {
      this.isFocus = false
    },
    async search() {
      this.isSearch = true
      this.currentSearchStr = this.formSearch.search
      let res = await getCompanyLists({ keywords: this.formSearch.search })
      this.searchList = res.result || []
      this.isSearch = false
    },
    goSearch() {
      this.isFocus = false
      let searchStr = {}
      if (this.formSearch.search) {
        searchStr.name = this.formSearch.search
        this.setHistory(this.formSearch.search)
      }
      clickUrl('/search/1', { search: JSON.stringify(searchStr), type: 2 })
    },
    toMatchDetail(arg) {
      this.setHistory(arg.name)
      clickUrl('/search/1', { search: JSON.stringify(arg), type: 1 })
      this.isFocus = false
    },
    setHistory(val) {
      if (!val) {
        return false
      }
      let history = getSearchHistory()
      if (!history.length) {
        this.stoageHistory.unshift(val)
        setSearchHistory(this.stoageHistory)
        return false
      }
      if (this.stoageHistory.indexOf(val) != -1) {
        this.stoageHistory.splice(this.stoageHistory.indexOf(val), 1)
        this.stoageHistory.unshift(val)
      } else {
        this.stoageHistory.unshift(val)
      }

      if (this.stoageHistory.length > 6) {
        this.stoageHistory.pop()
      }
      setSearchHistory(this.stoageHistory)
    },
    updateSearchStr(arg) {
      // this.formSearch.search = arg
       let searchStr = {
        name: arg
      }
      clickUrl('/search/1', { search: JSON.stringify(searchStr), type: 2 })
    },
    async getData() {
      let res = await getLatestRecord({ pageSize: 50 })
      this.hots = res.result.data.map(item => {
        return {
          ...item,
          nameView: desensitization(item.search_company_name, 4, 2)
        }
      }) || []
      this.finished = this.hots.length ? true : false
      this.emptyShow = !this.hots.length ? true : false
    },
    goSearchV2() {
      clickUrl('/enterprise_match')
    }
  }
}

function debounce(func, wait = 1000) { //可以放入项目中的公共方法中进行调用
  let timeout;
  return function (event) {
    clearTimeout(timeout)
    timeout = setTimeout(() => {
      func.call(this, event)
    }, wait)
  }
}
</script>

<style lang="scss" scoped>
.title {
  font-size: 24px;
  font-weight: bold;
  color: #FFF;
  position: relative;
  margin: 50px 10px 20px;
}

.sub-title {
  font-size: 18px;
  font-weight: 500;
  color: #FFF;
  line-height: 21px;
  position: relative;
  margin: 10px;
}

.header {
  margin: 35px auto 20px;
  // background: linear-gradient(219deg, #FFFFFF 0%, #1293ED 100%);
  background: #CFECFF;
  border-radius: 20px;
  padding: 20px 12px;
  position: relative;
  border: 1px solid #fff;
}

.match-container-search {
  height: 42px;
  // margin: 0 12px;
  border: 1px solid #189FF2;
  // background: #d7f0ff;
  border-radius: 26px;
  display: flex;
  position: relative;
  display: flex;
  flex-direction: row;
  background: #fff;
  box-shadow: 0px 4px 4px 1px rgba(96, 178, 236, 0.25);

  input {
    flex: 1;
    height: 36px;
    border-top-left-radius: 26px;
    border-bottom-left-radius: 26px;
    border: 0;
    // border-right: 2px solid #ededed;
    border-right: 2px solid #fff;
    box-sizing: border-box;
    padding: 0 8px 0 30px;
    font-size: 12px;
    // background: #d7f0ff;
    background: #fff;
    margin: 4px 0;

    &::placeholder {
      color: #808080;
    }
  }

  .btn {
    width: 60px;
    height: 36px;
    background: #0F96E9;
    border-radius: 26px;
    border: 1px solid rgba(255, 255, 255, 0.8);
    display: flex;
    align-items: center;
    justify-content: center;
    margin: auto 3px auto 7px;

    img {
      width: 27px;
      background-size: contain;
    }
  }

  .detail {
    width: 100%;
    position: absolute;
    top: 48px;
    left: 0px;
    z-index: 999;
  }
}

.search-hot-list {
  .policy-file-item {
    background: #FFF;
    border-radius: 8px;
    padding: 6px 10px;
    margin: 8px 0;
    color: #999;
    display: flex;

    .dot {
      width: 10px;
      height: 10px;
      border-radius: 50%;
      background: #0D86F3;
      margin-right: 4px;
      margin-top: 2px;
    }


    .color_1 {
      color: #000;
    }

    .color_2 {
      color: #FF642E
    }
  }
}
</style>
